import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const getInitialLang = () => {
  const saved = typeof window !== "undefined" ? localStorage.getItem("ed_lang") : null;
  if (saved && translations[saved]) return saved;
  return "cs";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    try {
      localStorage.setItem("ed_lang", code);
      document.documentElement.lang = code;
    } catch (e) {
      /* ignore */
    }
  }, []);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.cs[key] ?? key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export default LanguageContext;
